import App from './frontend/App';
import { DataProvider } from './frontend/hooks/useDataContext.js';
import { render } from '@wordpress/element';

const rootElements = document.querySelectorAll('.wp-block-gravity-episode-player');

rootElements.forEach((element) => {

    const dataSource = element.getAttribute('data-source');
    const title = element.getAttribute('data-title');
    const manualAudio = element.getAttribute('data-manual-audio');
    const description = element.getAttribute('data-description');
    const embedId = element.getAttribute('data-embed-id');
    const dataDynamic = element.getAttribute('data-dynamic');
    const postsCount = element.getAttribute('data-posts-count');
    const postsPerView = element.getAttribute('data-posts-per-view');
    const imageURL = element.getAttribute('data-media-url');
    const pageId = element.getAttribute('data-pageId') || window.currentPageID;
    const apiUrl = `/wp-json/nwm/v1/${dataDynamic}`;
    const episodeSlug = element.getAttribute('data-episodeSlug');

    render(
        <DataProvider>
            <App
                title={title}
                audioURL={manualAudio}
                description={description}
                imageURL={imageURL}
                source={dataSource}
                dataDynamic={dataDynamic}
                apiUrl={apiUrl}
                pageId={pageId}
                episodeSlug={episodeSlug}
                embedId={embedId}
                postsCount={postsCount}
                postsPerView={postsPerView}
            />
        </DataProvider>,
        element
    );
});
